/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentProcedureSimulationsRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations';

export default AutomationFinAIAgentProcedureSimulationsRoute;
